import { AlmConfigurationActionTypes, AlmConfigurationActions } from './alm-configuration.actions';
import { IAlmConfiguration } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IAlmConfiguration | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: AlmConfigurationActions): State {
    switch (action.type) {

        case AlmConfigurationActionTypes.LoadAlmConfigurationState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case AlmConfigurationActionTypes.LoadAlmConfigurationStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case AlmConfigurationActionTypes.LoadAlmConfigurationStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case AlmConfigurationActionTypes.AlmConfigurationScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;